<!-- //
新做法
@auth xuyd
@date 2024-05-02
//-->
<template>
  <div class="props-form">
    <component v-if="selectedWidget"
               :is="selectedWidget.widgetProps.widgetFormName"
               :widget-props="selectedWidget.widgetProps">
    </component>
    <component v-else :is="'WidgetWorkbench'" :widget-props="workbenchProps"/>
    <!-- 组件数据 -->
    <span style="color: #f1f1f1;width: 100%;word-break: break-all;">
      {{ JSON.stringify(this.selectedWidget) }}
    </span>
  </div>
</template>

<script>

import {widgetPackage} from '../../widget/index.js';
import * as WidgetUtil from "@/views/datavisual/utils/util";
import {widgetMenuList} from "@/views/datavisual/widget/widgetMenu"; // 组件库

// 工具栏配置的组件注册{FormXXX:{}, ViewXXX: {}}
const regComponents = WidgetUtil.registerWidget(widgetMenuList, widgetPackage);

export default {
  name: 'WbWidgetProps',
  components: {...regComponents},
  data() {
    return {}
  },
  props: {
    selectedWidget: Object,
    workbenchProps: Object,
  },
}
</script>

<style scoped lang="less">
.props-form {
  width: 350px;
  min-width: 350px;
  height: 100%;
  //background-color: @dv_background_bg;
}
</style>
